export default "__VITE_ASSET__EPsVJZL4__"